import { render, staticRenderFns } from "./medicalRecord.vue?vue&type=template&id=0e98b008&scoped=true&"
import script from "./medicalRecord.vue?vue&type=script&lang=js&"
export * from "./medicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./medicalRecord.vue?vue&type=style&index=0&id=0e98b008&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e98b008",
  null
  
)

component.options.__file = "medicalRecord.vue"
export default component.exports